import { Styles } from 'react-jss';

type MediaType = 'min' | 'max';
type MediaWidth = string | number;
type ResponsiveStyles = Styles;

function responsive(type: MediaType, size: MediaWidth, styles: ResponsiveStyles): ResponsiveStyles {
  const unit = typeof size === 'number' ? 'px' : '';
  return {
    [`@media (${type}-width: ${size}${unit})`]: styles,
  };
}

/**
 * responsiveMin - provides a @media jss properties for min-width
 * @param {MediaWidth} size - the width value, with or without unit of the media
 * @param {ResponsiveStyles} styles - the properties to apply for the media width
 * @returns {ResponsiveStyles} - the media properties
 *
 * @example
 * ```js
 * const useStyles = createUseStyles({
 *   width: '100%',
 *   ...responsiveMin(480, {
 *     width: '100px'
 *   })
 * });
 * // result: 100% <= 480px > 100px
 * ```
 */
export function responsiveMin(size: MediaWidth, styles: ResponsiveStyles): ResponsiveStyles {
  return responsive('min', size, styles);
}

/**
 * responsiveMax - provides a @media jss properties for min-width
 * @param {MediaWidth} size - the width value, with or without unit of the media
 * @param {ResponsiveStyles} styles - the properties to apply for the media width
 * @returns {ResponsiveStyles} - the media properties
 *
 * @example
 * ```js
 * const useStyles = createUseStyles({
 *   width: '100px',
 *   ...responsiveMax(480, {
 *     width: '100%'
 *   })
 * });
 * // result: 100% <= 480px > 100px
 * ```
 */
export function responsiveMax(size: MediaWidth, styles: ResponsiveStyles): ResponsiveStyles {
  return responsive('max', size, styles);
}
